// English translations
export const en = {
  // Top bar
  brand: '墨卡 Moka',
  singleMode: 'Single',
  multiMode: 'Multi',
  lightMode: 'Light mode',
  darkMode: 'Dark mode',
  
  // Left panel
  template: 'Template',
  style: 'Style',
  palette: 'Palette',
  content: 'Content',
  settings: 'Settings',
  generateSingle: 'Generate Single Page',
  generateSplit: 'Generate Cards',
  generating: 'Generating...',
  selectTemplate: 'Select Template',
  cardStyle: 'Card Style',
  aiReferenceImage: 'AI Reference Image (Optional)',
  aiReferenceImageWith: 'AI will reference this image style',
  aiReferenceImageWithout: 'AI will generate freely',
  
  // Page mode
  pageMode: 'Page Mode',

  // Platform
  xiaohongshu: 'Xiaohongshu',
  xiaohongshuTag: 'Emotional',
  wechat: 'WeChat',
  wechatTag: 'Professional',
  platform: 'Platform',
  
  // Center preview
  preview: 'Preview',
  hd: 'HD',
  ultra: '4K',
  current: 'Current',
  exportAll: 'Export All',
  generating: 'Generating...',
  singlePagePreview: 'Single Page Preview',
  multiPagePreview: 'Multi-Page Preview',
  emptyDesc: 'Enter content on the right and click generate',
  switchTemplate: 'Switch template',
  dragToResize: 'Drag to resize',
  clickToEdit: 'Click to edit',
  
  // LLM config modal
  llmConfigTitle: 'Configure LLM',
  llmConfigSubtitle: 'No LLM configuration detected. Please fill in the information below to continue using AI generation.',
  providerType: 'Provider Type',
  baseUrlLabel: 'Base URL',
  baseUrlOptional: 'Optional, default',
  baseUrlRequired: 'Required',
  baseUrlPlaceholder: 'Enter API base URL, e.g.: https://api.example.com/v1',
  apiKey: 'API Key',
  apiKeyPlaceholder: 'Enter your API Key',
  apiKeyRequired: 'Please enter API Key',
  modelLabel: 'Model',
  modelOptional: 'Optional, default',
  modelRequired: 'Required',
  modelPlaceholder: 'Enter model name, e.g.: gpt-4o-mini',
  save: 'Save Configuration',
  saving: 'Saving...',
  testing: 'Testing...',
  testAndSave: 'Test & Save',
  configSuccess: 'Configuration verified and saved successfully!',
  confirm: 'Confirm',
  cancel: 'Cancel',
  delete: 'Delete Current Config',
  deleteConfirm: 'Are you sure you want to delete the current configuration? Default configuration will be used after deletion.',
  confirmDelete: 'Confirm Delete',
  deleting: 'Deleting...',
  saveFailed: 'Save failed, please try again',
  noApiKey: "Don't have an API Key?",
  goToProvider: 'Get one →',
  aliyunProviderName: 'Aliyun Bailian',
  apiKeyConfigured: 'API Key configured, unlimited usage',

  // AI Config
  aiConfig: 'AI Configuration',
  edit: 'Edit',
  freeTrial: 'Free Trial',
  leftToday: 'left today',
  configureApiKey: 'Configure your API Key for unlimited usage',
  configure: 'Configure',

  // Content placeholders
  contentPlaceholderSingle: 'Enter your content, AI will generate beautiful single-page layout...',
  contentPlaceholderMulti: 'Enter your content, AI will generate multi-page cards...',

  // Generate buttons
  generateLayout: 'Generate Layout',
  generateCards: 'Generate Cards',

  // Provider names
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  
  // Error messages
  generateFailed: 'Generation failed',
  exportFailed: 'Export failed',
  saved: 'Saved',
  
  // Tips
  tipsTitle: 'Tips',
  tipEdit: 'Click on text in preview to edit directly',
  tipReorder: 'Drag thumbnails at bottom to reorder in split mode',
  tipHdExport: 'Export HD for social media',
  tipUltraExport: 'Export 4K Ultra for printing',
  
  // Language switch
  language: 'Language',
  chinese: '中文',
  english: 'English',
  
  // Template names
  templateClean: 'Clean Line',
  templateEditorial: 'Editorial',
  templateCreamy: 'Creamy',
  templateRetro: 'Retro',
  templateForest: 'Forest',
  templateIns: 'Instagram',
  templateJapanese: 'Japanese',
  templateKorean: 'Korean',
  templatePure: 'Pure Minimal',
  templatePop: 'Pop Art',
  templateArtistic: 'Artistic',
  templateVivid: 'Vivid Block',
  templateDark: 'Dark Mode',
  templatePaper: 'Bullet Journal',
  templateGradient: 'Gradient',
  templateLuxury: 'Luxury',
  templateBusiness: 'Business',
  templateTech: 'Tech',
  templateEdu: 'Education',
  templateMedical: 'Medical',
  templateFinance: 'Finance',
  templateLaw: 'Legal',
  templateFood: 'Food',
  templateTravel: 'Travel',
  templateFashion: 'Fashion',
  templateMom: 'Parenting',
  templateNotecard: 'Notecard',
  templateMinimal: 'Minimal',
  templateStamp: 'Stamp',
  templateBold: 'Bold Block',
  templateNewspaper: 'Newspaper',
  templateFilm: 'Film',
  templateLabel: 'Label',
  templateAiDesign: 'AI Design',
  
  // Palette names
  paletteCoral: 'Coral',
  paletteSage: 'Matcha',
  paletteInk: 'Ink',
  paletteAmber: 'Amber',
  palettePlum: 'Plum',
  paletteSlate: 'Slate',
  paletteRust: 'Rust',
  palettePine: 'Pine',

  // Mobile tabs
  styleTab: 'Style',
  previewTab: 'Preview',
  contentTab: 'Content',
};

export default en;
